/* ============================================================================
   AMES — showroom a preventivo
   Nessun carrello/checkout: due liste lato client in localStorage
     · AMES.preventivi  → richiesta preventivo (RFQ)
     · AMES.confronto   → tabella confronto specifiche
   ========================================================================== */
(function () {
  "use strict";

  var KEY_Q = "ames_preventivi_v1";
  var KEY_C = "ames_confronto_v1";
  var MAX_C = 4; // confronto: max 4 prodotti come da mockup

  /* ---------- store helpers ------------------------------------------------ */
  /* Una lista salvata male (un oggetto al posto dell'array, voci null da una
     versione vecchia) non deve bloccare per sempre i pulsanti: prima ogni
     aggiunta finiva in "arr.reduce is not a function" e il cliente non poteva
     piu' mettere nulla nel preventivo finche' non svuotava il browser. */
  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key));
      /* .map(pulito): anche le voci salvate prima del 20/10/2026 perdono i parametri _pos/_sid */
      return Array.isArray(v) ? v.filter(function (x) { return x && typeof x === "object"; }).map(pulito) : [];
    }
    catch (e) { return []; }
  }
  /* Le chiavi arrivano dal DOM (data-ames-remove, data-q-input) sempre come
     stringa, mentre l'id prodotto salvato da una card e' un numero: con ===
     "Rimuovi" e il cambio quantita' non trovavano mai la voce. */
  function keyOf(x) { return String(x.variantId || x.id); }
  function write(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
    syncBadges();
    document.dispatchEvent(new CustomEvent("ames:store", { detail: { key: key } }));
  }
  /* Stesso articolo: la variante conta solo se ce l'hanno tutti e due. Dalla
     card il prodotto entra senza variante, dalla scheda con: confrontando
     "variante o id" lo stesso trapano finiva due volte in lista (20/10/2026). */
  function same(a, b) {
    if (a.variantId && b.variantId) return String(a.variantId) === String(b.variantId);
    return String(a.id) === String(b.id);
  }
  function find(arr, item) {
    for (var i = 0; i < arr.length; i++) {
      if (same(arr[i], item)) return i;
    }
    return -1;
  }
  /* B13 (20/10/2026): dalla ricerca il prodotto arrivava con i parametri di
     tracciamento di Shopify (/products/x?_pos=1&_sid=...&_ss=r) e quell'indirizzo
     finiva nella richiesta di preventivo. Si tolgono i parametri che iniziano
     con "_"; gli altri (es. variant=) restano. */
  function pulisciUrl(u) {
    if (!u || typeof u !== "string" || u.indexOf("?") === -1) return u;
    var parti = u.split("#"), base = parti[0], ancora = parti[1];
    var q = base.split("?"), resto = (q[1] || "").split("&").filter(function (kv) {
      return kv && kv.charAt(0) !== "_";
    });
    return q[0] + (resto.length ? "?" + resto.join("&") : "") + (ancora ? "#" + ancora : "");
  }
  function pulito(it) { if (it && it.url) it.url = pulisciUrl(it.url); return it; }

  var Store = {
    quote: {
      all: function () { return read(KEY_Q); },
      has: function (it) { return find(read(KEY_Q), it) !== -1; },
      add: function (it) {
        pulito(it);
        var a = read(KEY_Q), i = find(a, it);
        if (i === -1) { it.qty = it.qty || 1; a.push(it); }
        else { a[i].qty = (a[i].qty || 1) + (it.qty || 1); }
        write(KEY_Q, a);
      },
      setQty: function (key, qty) {
        var a = read(KEY_Q);
        for (var i = 0; i < a.length; i++) {
          if (keyOf(a[i]) === String(key)) { a[i].qty = Math.max(1, qty); break; }
        }
        write(KEY_Q, a);
      },
      remove: function (key) {
        write(KEY_Q, read(KEY_Q).filter(function (x) { return keyOf(x) !== String(key); }));
      },
      clear: function () { write(KEY_Q, []); }
    },
    compare: {
      all: function () { return read(KEY_C); },
      has: function (it) { return find(read(KEY_C), it) !== -1; },
      toggle: function (it) {
        pulito(it);
        var a = read(KEY_C), i = find(a, it);
        if (i !== -1) { a.splice(i, 1); write(KEY_C, a); return false; }
        if (a.length >= MAX_C) {
          toast(window.AMES_T("compare_max", "Puoi confrontare al massimo {n} prodotti.").replace("{n}", MAX_C));
          return Store.compare.has(it);
        }
        a.push(it); write(KEY_C, a); return true;
      },
      remove: function (key) {
        write(KEY_C, read(KEY_C).filter(function (x) { return keyOf(x) !== String(key); }));
      },
      clear: function () { write(KEY_C, []); }
    }
  };
  // refreshStates è definita più sotto: la funzione è hoisted, quindi il riferimento è valido.
  // Serve esposta perché le griglie renderizzate a runtime (filtri collezione) devono poter
  // ri-applicare lo stato "già nei preventivi / nel confronto" alle card appena create.
  window.AMES = { Store: Store, esc: esc, gridCard: gridCard, refresh: function () { refreshStates(); },
    /* Il menu Condividi (blocco piu' sotto) chiamava toast() fuori dal suo scope:
       "Copia link" copiava ma finiva in ReferenceError, senza conferma a video. */
    toast: function (m) { toast(m); } };

  /* ---------- badges ------------------------------------------------------- */
  // Il numero accanto a "Preventivi" conta le righe, non i pezzi. Sommando le
  // quantita' un solo capo streetwear (minimo 100 pezzi) faceva leggere
  // "100 Preventivi": sembrano cento richieste, e' un articolo solo. Il
  // confronto conta gia' le righe: ora i due numeri vogliono dire la stessa cosa.
  function syncBadges() {
    var q = read(KEY_Q).length, c = read(KEY_C).length;
    document.querySelectorAll("[data-badge='quote']").forEach(function (b) {
      b.textContent = q; b.classList.toggle("show", q > 0);
    });
    document.querySelectorAll("[data-badge='compare']").forEach(function (b) {
      b.textContent = c; b.classList.toggle("show", c > 0);
    });
    /* Mostra/nascondi le icone azioni nell'header in home mode in base al contenuto delle liste */
    document.querySelectorAll('[data-ames-header]').forEach(function (h) {
      h.classList.toggle('has-quote', q > 0);
      h.classList.toggle('has-compare', c > 0);
    });
  }

  /* ---------- toast -------------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "ames-toast";   /* posizione in ames.css: in alto su telefono, sopra le barre fisse */
      toastEl.style.cssText = "position:fixed;left:50%;transform:translateX(-50%);" +
        "background:#15181D;color:#fff;padding:.7rem 1.2rem;border-radius:999px;z-index:200;" +
        "font-size:.9rem;box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transition:.2s;pointer-events:none;max-width:90vw;text-align:center;";
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.opacity = "1";
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.style.opacity = "0"; }, 2200);
  }

  /* ---------- decode a product payload from a button ---------------------- */
  function payload(el) {
    // Il JSON sta una volta sola sulla card (article.pcard[data-product]); sulla PDP
    // resta sui singoli bottoni. Cerco prima sull'elemento, poi sull'antenato: stampare
    // lo stesso payload su tre bottoni per card costava il 27% dell'HTML di collezione.
    var host = el.hasAttribute("data-product") ? el : el.closest("[data-product]");
    if (!host) return null;
    var raw = host.getAttribute("data-product");
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  /* ---------- click delegation: add to quote / toggle compare ------------- */
  document.addEventListener("click", function (e) {
    var qBtn = e.target.closest("[data-ames-add='quote']");
    if (qBtn) {
      e.preventDefault();
      var it = currentSelection(qBtn) || payload(qBtn);
      if (it) {
        // Se c'era gia', il secondo clic alza la quantita': dirlo, altrimenti
        // sembra che il pulsante non abbia fatto niente.
        var cera = Store.quote.has(it);
        Store.quote.add(it);
        flash(qBtn);
        if (cera) {
          var q = 1;
          Store.quote.all().forEach(function (x) {
            if (same(x, it)) q = x.qty || 1;
          });
          toast(window.AMES_T("already_in_quote", "Già nel preventivo") + " — " +
                window.AMES_T("qty", "Quantità") + " " + q);
        } else {
          toast(window.AMES_T("added_to_quote", "Aggiunto ai preventivi"));
        }
        refreshStates();
      }
      return;
    }
    var cBtn = e.target.closest("[data-ames-add='compare']");
    if (cBtn) {
      e.preventDefault();
      var it2 = currentSelection(cBtn) || payload(cBtn);
      if (it2) {
        var on = Store.compare.toggle(it2);
        cBtn.classList.toggle("is-on", on);
        refreshStates();
        if (on) {
          toast(window.AMES_T("added_to_compare", "Aggiunto al confronto") + " · " + Store.compare.all().length + "/" + MAX_C);
          /* con un prodotto solo il confronto non confronta niente: si apre dal secondo */
          if (window.AMES_CMP && Store.compare.all().length >= 2) window.AMES_CMP.open();
        } else {
          toast(window.AMES_T("removed_from_compare", "Rimosso dal confronto"));
        }
      }
      return;
    }
    var rm = e.target.closest("[data-ames-remove]");
    if (rm) {
      e.preventDefault();
      var key = rm.getAttribute("data-ames-remove");
      if (rm.getAttribute("data-store") === "compare") Store.compare.remove(key);
      else Store.quote.remove(key);
    }
  });

  function flash(btn) {
    btn.classList.add("is-on");
    setTimeout(function () {
      // su pagine non-PDP il pulsante torna neutro dopo il feedback
      if (!btn.hasAttribute("data-persist")) btn.classList.remove("is-on");
    }, 900);
  }

  /* ---------- targhetta di stato sulle card ------------------------------- */
  // Scorrendo 1.500 prodotti il cliente deve vedere cosa ha gia' messo dove,
  // senza aprire niente. Il colore da solo non basta: la targhetta lo scrive.
  function refreshChips() {
    var q = Store.quote.all(), c = Store.compare.all();
    document.querySelectorAll("[data-stato-chip]").forEach(function (chip) {
      var host = chip.closest("[data-product]");
      if (!host) return;
      var it;
      try { it = JSON.parse(host.getAttribute("data-product")); } catch (e) { return; }
      if (!it) return;
      var inQ = Store.quote.has(it), inC = Store.compare.has(it);
      var eq = chip.querySelector("[data-stato-q]"), ec = chip.querySelector("[data-stato-c]");
      if (eq) eq.hidden = !inQ;
      if (ec) ec.hidden = !inC;
      chip.hidden = !(inQ || inC);
      host.classList.toggle("is-in-quote", inQ);
      host.classList.toggle("is-in-compare", inC);
    });
  }

  // reflect current store state onto compare + quote buttons (persistent toggle)
  function refreshStates() {
    // NB: i CTA della pagina prodotto ([data-pdp-cta]) hanno identita' per VARIANTE
    // e vengono gestiti dallo script della sezione: qui vanno esclusi.
    document.querySelectorAll("[data-ames-add='compare'][data-persist]:not([data-pdp-cta])").forEach(function (b) {
      var it = payload(b); if (it) b.classList.toggle("is-on", Store.compare.has(it));
    });
    document.querySelectorAll("[data-ames-add='quote'][data-persist]:not([data-pdp-cta])").forEach(function (b) {
      var it = payload(b); if (it) b.classList.toggle("is-on", Store.quote.has(it));
    });
    // aria-pressed: chi naviga con lo screen reader deve sentire lo stato,
    // non solo vederlo.
    document.querySelectorAll("[data-ames-add][aria-pressed]").forEach(function (b) {
      b.setAttribute("aria-pressed", b.classList.contains("is-on") ? "true" : "false");
    });
    refreshChips();
  }

  /* ---------- product page selection (variant + qty) ---------------------- */
  function currentSelection(btn) {
    var pdp = document.querySelector("[data-pdp]");
    if (!pdp || !btn.closest("[data-pdp]") && !btn.hasAttribute("data-pdp-cta")) return null;
    // Dentro la PDP vivono anche card di altri prodotti (setup consigliato, correlati).
    // Se il bottone porta gia' un payload suo, quello vince: senza questo controllo un
    // click su "aggiungi ai preventivi" di un accessorio aggiungeva il prodotto principale.
    var own = btn.hasAttribute("data-product") ? btn : btn.closest("[data-product]");
    if (own && !btn.hasAttribute("data-pdp-cta") && own !== pdp.querySelector("[data-pdp-payload]")) return null;
    var base = payload(pdp.querySelector("[data-pdp-payload]")) || {};
    var sel = pdp.querySelector("[data-variant-id]");
    var qtyEl = pdp.querySelector("[data-qty-input]");
    var item = Object.assign({}, base);
    if (sel) {
      item.variantId = sel.value;
      item.variantTitle = sel.getAttribute("data-variant-title") || base.variantTitle || "";
    }
    if (qtyEl) item.qty = parseInt(qtyEl.value, 10) || 1;
    return item;
  }

  /* ---------- variant picker (radios -> hidden current variant) ----------- */
  function initVariants() {
    var pdp = document.querySelector("[data-pdp]");
    if (!pdp) return;
    var data = pdp.querySelector("[data-variants-json]");
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var current = pdp.querySelector("[data-variant-id]");

    function selectedOptions() {
      var opts = [];
      pdp.querySelectorAll("[data-option-index]").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked ? checked.value : null;
      });
      return opts;
    }
    function match() {
      var want = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return want[i] == null || want[i] === o; });
      });
    }
    function update() {
      var v = match() || variants[0];
      if (!v || !current) return;
      current.value = v.id;
      current.setAttribute("data-variant-title", v.title);
      // disable options that produce no available combination
    }
    pdp.addEventListener("change", function (e) {
      if (e.target.matches("[data-option-index] input")) update();
    });
    update();
  }

  /* ---------- tabs (Descrizione / Specifiche) ----------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-tab]");
    if (!t) return;
    var scope = t.closest("[data-tabs]");
    if (!scope) return;
    var name = t.getAttribute("data-tab");
    scope.querySelectorAll("[data-tab]").forEach(function (b) { b.classList.toggle("is-active", b === t); });
    scope.querySelectorAll("[data-tab-panel]").forEach(function (p) {
      p.classList.toggle("is-active", p.getAttribute("data-tab-panel") === name);
    });
  });

  /* ---------- gallery ------------------------------------------------------
     Premendo una miniatura la foto grande non cambiava. Cambiava il `src` —
     nel DOM si vedeva il nome nuovo — ma a video restava la prima foto, e le
     altre immagini del prodotto erano di fatto irraggiungibili.

     Il motivo: la foto grande ha un `srcset` con quattro misure. Quando c'e'
     un srcset il browser sceglie da li' e il `src` lo guarda soltanto se non
     trova di meglio: cambiarlo da solo non sposta un pixel. Va rifatto anche
     il srcset, con le stesse quattro misure della foto nuova. */
  function srcsetDa(url) {
    /* Gli indirizzi Shopify portano la misura come parametro: basta
       riscriverla. Se non c'e', si lascia perdere il srcset. */
    if (!/[?&]width=\d+/.test(url)) return "";
    return [480, 800, 1200, 1600].map(function (w) {
      return url.replace(/([?&]width=)\d+/, "$1" + w) + " " + w + "w";
    }).join(", ");
  }

  document.addEventListener("click", function (e) {
    var th = e.target.closest("[data-gallery-thumb]");
    if (!th) return;
    var g = th.closest("[data-gallery]") || th.closest(".pdp__gallery");
    if (!g) return;
    var main = g.querySelector("[data-gallery-main] img");
    var url = th.getAttribute("data-src");
    if (main && url) {
      var ss = srcsetDa(url);
      if (ss) main.setAttribute("srcset", ss); else main.removeAttribute("srcset");
      main.src = url;
      /* La foto nuova ha proporzioni sue: le misure scritte nel tag erano
         quelle della prima, e il riquadro restava della forma sbagliata
         finche' non finiva di caricare. */
      main.removeAttribute("width");
      main.removeAttribute("height");
    }
    g.querySelectorAll("[data-gallery-thumb]").forEach(function (b) {
      var attiva = b === th;
      b.classList.toggle("is-active", attiva);
      /* Lo stato lo leggeva solo il CSS. Chi naviga con un lettore di schermo
         non sapeva quale delle otto miniature fosse quella a video. */
      if (attiva) b.setAttribute("aria-current", "true");
      else b.removeAttribute("aria-current");
    });
  });

  /* ---------- qty steppers (cards + pdp + preventivi) --------------------- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-step]");
    if (!step) return;
    var box = step.closest(".qty-stepper");
    var input = box.querySelector("input");
    var v = parseInt(input.value, 10) || 1;
    v += step.getAttribute("data-step") === "up" ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- predictive search ------------------------------------------- */
  function initSearch() {
    document.querySelectorAll("[data-search]").forEach(function (wrap) {
      var input = wrap.querySelector("[data-search-input]");
      var panel = wrap.querySelector("[data-search-results]");
      if (!input || !panel) return;
      var timer, last = "";
      input.addEventListener("input", function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { panel.classList.remove("open"); panel.innerHTML = ""; return; }
        timer = setTimeout(function () { run(q); }, 220);
      });
      input.addEventListener("focus", function () { if (panel.innerHTML) panel.classList.add("open"); });
      document.addEventListener("click", function (ev) {
        if (!wrap.contains(ev.target)) panel.classList.remove("open");
      });

      function run(q) {
        if (q === last) { panel.classList.add("open"); return; }
        last = q;
        var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=show";
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          render(d.resources.results, q);
        }).catch(function () {});
      }
      function render(res, q) {
        var cols = (res.collections || []);
        var prods = (res.products || []);
        var html = '<div class="ps">';
        html += '<div class="ps__col"><div class="ps__h">' + window.AMES_T("products","Prodotti") + '</div>';
        if (prods.length) prods.forEach(function (p) {
          html += '<a class="ps__row" href="' + p.url + '">' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" decoding="async" width="300" height="300">' : '<span class="ps__noimg"></span>') +
            '<span>' + esc(p.title) + '</span></a>';
        }); else html += '<div class="ps__empty">' + window.AMES_T("no_products","Nessun prodotto") + '</div>';
        html += '</div>';
        html += '<div class="ps__col ps__col--side"><div class="ps__h">' + window.AMES_T("collections","Collezioni") + '</div>';
        if (cols.length) cols.forEach(function (c) {
          html += '<a class="ps__chip" href="' + c.url + '">' + esc(c.title) + '</a>';
        }); else html += '<div class="ps__empty">—</div>';
        html += '<a class="ps__all" href="' + (window.AMES_ROOT || "/") + 'search?q=' + encodeURIComponent(q) + '">' + window.AMES_T("see_all_results","Vedi tutti i risultati →") + '</a>';
        html += '</div></div>';
        panel.innerHTML = html;
        panel.classList.add("open");
      }
    });
  }
  /* `(s || "").replace(...)` presuppone una stringa. Nel payload dei prodotti
     ci sono numeri (id, qty) e array (tags): su quelli .replace non esiste e la
     funzione lancia TypeError. Siccome esc() e' usata dentro i render di
     Preventivi e Confronto, una sola chiamata sbagliata svuotava l'intera
     pagina — ed e' esattamente cio' che succedeva sulla pagina Confronto.
     Qui si converte sempre a stringa prima di sostituire. */
  function esc(s) { return String(s === null || s === undefined ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
  }); }

  /* ---------- card prodotto condivisa (griglia animata: ricerca + hub) -----
     Stessa struttura/markup usata da risultati-ricerca.liquid (prefix
     "ames-rr-card") e main-hub-macro.liquid (prefix "ames-hub-card") — solo
     il prefisso classe cambia, il CSS resta scoped in ciascuna section. */
  function gridCard(p, opts) {
    opts = opts || {};
    var prefix = opts.prefix || "ames-rr-card";
    var i = opts.index || 0;
    var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || "";
    /* si vende a preventivo: un prezzo 0 non si mostra (prima "0.00" su ogni scheda) */
    var price = parseFloat(p.price) > 0 ? ('<span class="' + prefix + '__price">' + esc(p.price) + "</span>") : "";
    var cls = prefix + (opts.extraClass ? " " + opts.extraClass : "");
    var url = String(p.url || "").split("?")[0];
    return '<a class="' + cls + '" href="' + esc(url) + '" style="--i:' + i + '">'
      + '<span class="' + prefix + '__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async" width="300" height="300">' : '<span class="' + prefix + '__ph"></span>') + "</span>"
      + '<span class="' + prefix + '__lab">' + esc(p.title) + "</span>"
      + (p.vendor ? '<span class="' + prefix + '__meta">' + esc(p.vendor) + "</span>" : "")
      + price
      + (opts.chipsHtml || "")
      + "</a>";
  }

  /* ---------- search mode toggle (professione / settore) ------------------ */
  document.addEventListener("click", function (e) {
    var m = e.target.closest("[data-search-mode]");
    if (!m) return;
    var wrap = m.closest("[data-search]") || document.querySelector("[data-search]");
    if (!wrap) return;
    wrap.querySelectorAll("[data-search-mode]").forEach(function (b) {
      var on = b === m;
      b.classList.toggle("btn--primary", on);
      b.classList.toggle("btn--ghost", !on);
    });
    var input = wrap.querySelector("[data-search-input]");
    var mode = m.getAttribute("data-search-mode");
    if (input) input.setAttribute("placeholder",
      mode === "professione" ? "Cerca per professione…" :
      mode === "settore" ? "Cerca per settore…" : "Cosa cerchi? Cosa devi fare?");
  });

  /* ---------- category flyout (desktop) ----------------------------------- */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest("[data-flyout-trigger]");
    if (trig) {
      e.preventDefault();
      var id = trig.getAttribute("data-flyout-trigger");
      var fly = document.querySelector('[data-flyout="' + id + '"]');
      document.querySelectorAll("[data-flyout]").forEach(function (f) { if (f !== fly) f.classList.remove("open"); });
      if (fly) fly.classList.toggle("open");
      return;
    }
    if (!e.target.closest("[data-flyout]") && !e.target.closest("[data-flyout-trigger]")) {
      document.querySelectorAll("[data-flyout]").forEach(function (f) { f.classList.remove("open"); });
    }
  });

  /* ---------- mobile drawer ------------------------------------------------ */
  function initDrawer() {
    var drawer = document.querySelector(".mobile-drawer");
    if (!drawer) return;   // il cassetto vero e' in header.liquid: qui si apriva solo una seconda velatura
    var scrim = document.querySelector(".scrim");
    function open() { drawer && drawer.classList.add("open"); scrim && scrim.classList.add("open"); }
    function close() { drawer && drawer.classList.remove("open"); scrim && scrim.classList.remove("open"); }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-drawer-open]")) { e.preventDefault(); open(); }
      else if (e.target.closest("[data-drawer-close]") || e.target === scrim) close();
    });
  }

  /* ---------- boot --------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    syncBadges();
    refreshStates();
    initVariants();
    initSearch();
    initDrawer();
    // re-render dynamic pages on store change
    document.addEventListener("ames:store", function () {
      if (window.AMESQuote) window.AMESQuote.render();
      if (window.AMESCompare) window.AMESCompare.render();
    });
  });
})();

/* ---- horizontal carousel arrows + native share (appended) ---- */
(function () {
  document.addEventListener("click", function (e) {
    var nav = e.target.closest("[data-scroll]");
    if (nav) {
      var sel = nav.getAttribute("data-scroll-target");
      var track = sel ? document.querySelector(sel) : nav.parentElement.querySelector("[data-track]");
      if (track) track.scrollBy({ left: (nav.getAttribute("data-scroll") === "next" ? 1 : -1) * track.clientWidth * 0.8, behavior: "smooth" });
      return;
    }
    var sh = e.target.closest("[data-share]");
    if (sh) {
      e.preventDefault();
      openShareMenu(sh);
      return;
    }
    if (!e.target.closest("[data-share-menu]")) closeShareMenu();
    /* P4 (20/10/2026): "Copia" accanto al codice articolo della scheda. Nel B2B
       il codice si incolla nell'ordine o nel gestionale: ricopiarlo a mano da
       telefono e' il modo piu' sicuro di sbagliare una cifra. */
    var cp = e.target.closest("[data-copia]");
    if (cp) {
      e.preventDefault();
      var testo = cp.getAttribute("data-copia") || "";
      (navigator.clipboard ? navigator.clipboard.writeText(testo) : Promise.reject())
        .then(function () {
          avvisa(window.AMES_T("code_copied", "Codice copiato") + ": " + testo);
          cp.classList.add("is-on");
          setTimeout(function () { cp.classList.remove("is-on"); }, 1400);
        }, function () { avvisa(window.AMES_T("copy_failed", "Copia non riuscita")); });
    }
  });

  /* ---------- Condividi: menu Email / WhatsApp / Copia link ---------------- */
  function avvisa(m) { if (window.AMES && window.AMES.toast) window.AMES.toast(m); }
  var shareMenu = null;
  function closeShareMenu() {
    if (shareMenu) { shareMenu.remove(); shareMenu = null; }
  }
  function openShareMenu(btn) {
    if (shareMenu) { closeShareMenu(); return; }
    var url = btn.getAttribute("data-url") || location.href;
    var title = btn.getAttribute("data-title") || document.title;
    var eUrl = encodeURIComponent(url), eTitle = encodeURIComponent(title);
    shareMenu = document.createElement("div");
    shareMenu.setAttribute("data-share-menu", "");
    shareMenu.setAttribute("role", "menu");
    shareMenu.style.cssText = "position:absolute;z-index:130;background:#fff;border:1px solid #E4E6EA;" +
      "border-radius:12px;box-shadow:0 14px 40px -12px rgba(20,24,33,.28);padding:6px;min-width:190px";
    var item = "display:flex;align-items:center;gap:10px;width:100%;padding:10px 12px;border:none;background:none;" +
      "font:inherit;font-size:.94rem;color:#15181D;text-decoration:none;border-radius:8px;cursor:pointer;text-align:left";
    shareMenu.innerHTML =
      '<a role="menuitem" style="' + item + '" href="mailto:?subject=' + eTitle + '&body=' + eTitle + '%0A' + eUrl + '">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>Email</a>' +
      '<a role="menuitem" style="' + item + '" target="_blank" rel="noopener" href="https://wa.me/?text=' + eTitle + '%20' + eUrl + '">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>WhatsApp</a>' +
      '<button role="menuitem" type="button" style="' + item + '" data-share-copy>' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' + window.AMES_T("copy_link","Copia link") + '</button>';
    document.body.appendChild(shareMenu);
    var r = btn.getBoundingClientRect();
    shareMenu.style.left = Math.max(8, Math.min(r.left + window.scrollX, window.scrollX + window.innerWidth - 210)) + "px";
    shareMenu.style.top = (r.bottom + window.scrollY + 6) + "px";
    shareMenu.querySelector("[data-share-copy]").addEventListener("click", function () {
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
        .then(function () { avvisa(window.AMES_T("link_copied","Link copiato")); }, function () { avvisa(window.AMES_T("copy_failed","Copia non riuscita")); });
      closeShareMenu();
    });
    var first = shareMenu.querySelector("a,button");
    if (first) first.focus();
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeShareMenu();
  });
})();

/* ---- AMES_A11Y: focus-trap condiviso per i modali senza gestione tastiera
   (AMES_PR, AMES_INFO, AMES_CMP, AMES_QUOTE_M) — stesso pattern già usato in
   ames-search-modal.liquid/ames-specs-modal.liquid, centralizzato qui per non
   duplicarlo 4 volte. ---- */
window.AMES_A11Y = (function(){
  var lastFocus = null, trapEl = null, handler = null;
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusable(el){
    return Array.prototype.slice.call(el.querySelectorAll(SEL)).filter(function(n){ return n.offsetParent !== null; });
  }
  function trap(modal){
    if(!modal) return;
    lastFocus = document.activeElement;
    trapEl = modal;
    var items = focusable(modal);
    (items[0] || modal).focus();
    handler = function(e){
      if(e.key !== 'Tab' || !trapEl) return;
      var f = focusable(trapEl);
      if(!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', handler);
  }
  function release(){
    if(handler){ document.removeEventListener('keydown', handler); handler = null; }
    trapEl = null;
    if(lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  return { trap: trap, release: release };
})();

/* ---- B20 (20/10/2026): con una finestra aperta la pagina sotto diventa inerte ----
   Prima Tab e lettori di schermo raggiungevano ancora i link dietro al velo
   (Procurement, schede noleggio, confronto, preventivi, accessori...). Invece di
   toccare ogni script che apre una finestra si osservano le finestre stesse
   ([role=dialog][aria-modal=true] e il menu laterale): quando una si apre, tutto
   cio' che non la contiene prende `inert`; quando si chiude, lo si toglie.
   Mentre una finestra e' aperta <html> porta .ames-modale-aperta: ames.css
   nasconde la barra in basso, ma finora quella classe non la metteva nessuno. */
(function(){
  var SEL = '[role="dialog"][aria-modal="true"], #ames-drawer';
  var aperte = [];          // finestre aperte, in ordine di apertura
  var messi = new Map();    // finestra -> elementi resi inerti da lei
  function eAperta(el){
    if (el.id === 'ames-drawer') return el.classList.contains('open');
    return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && getComputedStyle(el).display !== 'none';
  }
  /* Non si toccano: script e stili, cio' che e' gia' inerte (resta com'e'),
     l'avviso a comparsa e i veli che chiudono il menu al tocco. */
  function salta(f){
    return f.tagName === 'SCRIPT' || f.tagName === 'STYLE' || f.tagName === 'LINK' ||
      f.hasAttribute('inert') || f.classList.contains('ames-toast') ||
      f.classList.contains('ames-scrim') || f.classList.contains('scrim') || f.hasAttribute('data-drawer-close');
  }
  function chiudiInerti(el){
    var lista = [], nodo = el;
    while (nodo && nodo !== document.body && nodo.parentElement){
      var padre = nodo.parentElement;
      for (var i = 0; i < padre.children.length; i++){
        var f = padre.children[i];
        if (f === nodo || f.contains(el) || salta(f)) continue;
        f.setAttribute('inert', ''); lista.push(f);
      }
      nodo = padre;
    }
    messi.set(el, lista);
  }
  function apriInerti(el){
    (messi.get(el) || []).forEach(function(f){ f.removeAttribute('inert'); });
    messi.delete(el);
  }
  function classe(){
    var vere = aperte.filter(function(d){ return d.id !== 'ames-drawer'; });
    document.documentElement.classList.toggle('ames-modale-aperta', vere.length > 0);
  }
  function controlla(el){
    var ora = eAperta(el), prima = aperte.indexOf(el) !== -1;
    if (ora && !prima){ aperte.push(el); chiudiInerti(el); }
    else if (!ora && prima){ aperte.splice(aperte.indexOf(el), 1); apriInerti(el); }
    classe();
  }
  function avvia(){
    if (!window.MutationObserver || !window.Map) return;
    var mo = new MutationObserver(function(ms){
      var visti = [];
      ms.forEach(function(m){ if (visti.indexOf(m.target) === -1){ visti.push(m.target); controlla(m.target); } });
    });
    document.querySelectorAll(SEL).forEach(function(el){
      mo.observe(el, { attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();

/* ---- AMES_PR: regolamento collassabile + modale richiesta noleggio ---- */
window.AMES_PR = (function(){
  var modal=null, els={}, current=null;

  function ensure(){
    if(modal) return modal;
    modal = document.querySelector('[data-rent-modal]');
    if(!modal) return null;
    /* Dentro .ames-page__wrap (z-index 1) la modale finiva sotto testata e barra in
       basso, e la sua X apriva "Preventivi": sul body sta sopra a tutto (20/10/2026). */
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    els = {
      img:  modal.querySelector('[data-rent-img-out]'),
      name: modal.querySelector('[data-rent-name-out]'),
      tag:  modal.querySelector('[data-rent-tag-out]'),
      desc: modal.querySelector('[data-rent-desc-out]'),
      qty:  modal.querySelector('[data-rent-qty-in]'),
      durV: modal.querySelector('[data-rent-dur-v]'),
      durU: modal.querySelector('[data-rent-dur-u]'),
      addrBox: modal.querySelector('[data-rent-addr]'),
      addrIn:  modal.querySelector('[data-rent-addr-in]'),
      brief:   modal.querySelector('[data-rent-brief]'),
      chipBox: modal.querySelector('[data-rent-chips-box]')
    };
    /* Delega sul contenitore: le pastiglie vengono riscritte a ogni apertura,
       agganciare i singoli pulsanti significherebbe riagganciarli ogni volta.
       Toccarne una scrive l'inizio della riga e lascia il cursore dopo i due
       punti: chi tocca "Pendenza della falda" si trova gia' pronto a scrivere
       il numero, che e' l'unica cosa che sa lui. */
    if (els.chipBox) els.chipBox.addEventListener('click', function(e){
      var c = e.target.closest('[data-rent-chip]');
      if (!c) return;
      var ta = els.brief; if (!ta) return;
      var et = c.getAttribute('data-rent-chip') || '';
      if (ta.value.indexOf(et + ':') !== -1) { ta.focus(); return; }
      var pre = ta.value.replace(/\s+$/, '');
      ta.value = (pre ? pre + String.fromCharCode(10) : '') + et + ': ';
      ta.focus();
      ta.setSelectionRange(ta.value.length, ta.value.length);
    });
    modal.querySelectorAll('[data-rent-mode]').forEach(function(r){
      r.addEventListener('change', function(){
        var loco = modal.querySelector('[data-rent-mode]:checked').value === 'in_loco';
        if (els.addrBox) els.addrBox.hidden = !loco;
        if (loco && els.addrIn) setTimeout(function(){ els.addrIn.focus(); }, 50);
      });
    });
    return modal;
  }

  return {
    toggleRules: function(btn){
      var box = btn.closest('[data-rules]'); if(!box) return;
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    },

    openRent: function(btn){
      try {
        if(!ensure()){ alert('Modale non trovato nel DOM. Ricarica la pagina.'); return; }
        var _ta = document.querySelector('[data-rent-brief]');
        if (_ta) _ta.value = '';
        /* Le domande e l'esempio sono quelli di questa scheda. */
        var _ph = btn.getAttribute('data-rent-ph');
        if (_ta) _ta.placeholder = _ph || _ta.getAttribute('data-ph-default') || '';
        var _box = document.querySelector('[data-rent-chips-box]');
        if (_box) {
          var _src = (btn.getAttribute('data-rent-chips') || _box.getAttribute('data-fallback') || '');
          _box.innerHTML = _src.split('\u00b7').map(function(x){ return x.trim(); })
            .filter(Boolean).map(function(x){
              var e = x.replace(/[&<>"]/g, function(c){
                return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; });
              return '<button type="button" data-rent-chip="' + e + '">' + e + '</button>';
            }).join('');
        }
        current = {
          img:  btn.getAttribute('data-rent-img'),
          name: btn.getAttribute('data-rent-name'),
          tag:  btn.getAttribute('data-rent-tag'),
          desc: btn.getAttribute('data-rent-desc'),
          handle: btn.getAttribute('data-rent-handle')
        };
        if(els.img){ els.img.src = current.img || ''; els.img.alt = current.name || ''; }
        if(els.name) els.name.textContent = current.name || 'Noleggio';
        if(els.tag){ els.tag.textContent = current.tag || ''; els.tag.hidden = !current.tag; }
        if(els.desc) els.desc.innerHTML = current.desc || '';
        if(els.qty)  els.qty.value = 1;
        if(els.durV) els.durV.value = 1;
        if(els.durU) els.durU.value = 'giorni';
        if(els.addrIn){ els.addrIn.value = ''; els.addrIn.style.borderColor = ''; }
        if(els.addrBox) els.addrBox.hidden = true;
        var rad = modal.querySelector('[data-rent-mode][value="ritiro"]'); if(rad) rad.checked = true;
        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.body.style.overflow = 'hidden';
        window.AMES_A11Y.trap(modal);
      } catch(e) {
        alert('Errore apertura modale: ' + e.message);
      }
    },

    close: function(){
      if(!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      window.AMES_A11Y.release();
    },

    stepQty: function(d){
      if(!ensure() || !els.qty) return;
      var v = (parseInt(els.qty.value,10) || 1) + (parseInt(d,10) || 0);
      els.qty.value = Math.max(1, Math.min(999, v));
    },

    addToQuote: function(){
      if(!ensure()) return;
      var Store = window.AMES && window.AMES.Store && window.AMES.Store.quote;
      if(!Store){ alert(window.AMES_T('quote_unavailable','Sistema preventivi non disponibile.')); return; }
      var mode = (modal.querySelector('[data-rent-mode]:checked')||{}).value || 'ritiro';
      var address = mode === 'in_loco' && els.addrIn ? (els.addrIn.value||'').trim() : '';
      if(mode === 'in_loco' && !address){
        if(els.addrIn){ els.addrIn.focus(); els.addrIn.style.borderColor = '#D32F2F'; }
        return;
      }
      var qty = Math.max(1, parseInt(els.qty.value,10) || 1);
      var dv  = Math.max(1, parseInt(els.durV.value,10)  || 1);
      var du  = els.durU.value || 'giorni';
      var uid = 'rent-' + Date.now() + '-' + Math.random().toString(36).slice(2,7);
      Store.add({
        id: (current && current.handle) || uid,
        variantId: uid,
        kind: 'noleggio',
        title: current ? current.name : 'Noleggio',
        url: window.location.pathname,
        image: current ? current.img : '',
        qty: qty,
        rental: { durationValue: dv, durationUnit: du, deliveryMode: mode, address: address,
                  brief: els.brief ? (els.brief.value || '').trim().slice(0, 900) : '' }
      });
      this.close();
      window.location.href = ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'pages/preventivi';
    }
  };
})();

document.addEventListener('keydown', function(e){
  var m = document.querySelector('[data-rent-modal]');
  if (e.key === 'Escape' && m && !m.hidden && window.AMES_PR) window.AMES_PR.close();
});

/* Fallback: anche se gli onclick non passassero, aggancia listener diretti */
(function attachRentListeners(){
  function attach(){
    document.querySelectorAll('[data-rules-toggle]').forEach(function(btn){
      if (btn.__amesBound) return; btn.__amesBound = true;
      btn.addEventListener('click', function(e){ e.preventDefault(); window.AMES_PR && window.AMES_PR.toggleRules(btn); });
    });
    document.querySelectorAll('[data-rent-open]').forEach(function(btn){
      if (btn.__amesBound) return; btn.__amesBound = true;
      btn.addEventListener('click', function(e){ e.preventDefault(); window.AMES_PR && window.AMES_PR.openRent(btn); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();

/* ---- AMES_INFO: modale informativa (griglia info_grid) ----
   Personalizzazioni e Riparazioni finivano su un link "Richiedi un preventivo"
   verso la pagina contatti: il cliente ripartiva da un foglio bianco e doveva
   riscrivere di quale famiglia stesse parlando. Ora, quando il blocco lo
   chiede, la modale raccoglie la richiesta li' dov'e' nata, come sul noleggio:
   la voce entra nella lista Preventivi con il nome della famiglia e il
   racconto del lavoro gia' attaccato. */
window.AMES_INFO = (function(){
  var modal=null, els={}, current=null;
  function ensure(){
    if(modal) return modal;
    modal = document.querySelector('[data-info-modal]');
    if(!modal) return null;
    els = {
      img:  modal.querySelector('[data-info-img-out]'),
      name: modal.querySelector('[data-info-name-out]'),
      tag:  modal.querySelector('[data-info-tag-out]'),
      desc: modal.querySelector('[data-info-desc-out]'),
      brief:   modal.querySelector('[data-info-brief]'),
      chipBox: modal.querySelector('[data-info-chips-box]')
    };
    /* Delega sul contenitore: le pastiglie vengono riscritte a ogni apertura. */
    if (els.chipBox) els.chipBox.addEventListener('click', function(e){
      var c = e.target.closest('[data-info-chip]');
      if (!c) return;
      var ta = els.brief; if (!ta) return;
      var et = c.getAttribute('data-info-chip') || '';
      if (ta.value.indexOf(et + ':') !== -1) { ta.focus(); return; }
      var pre = ta.value.replace(/\s+$/, '');
      ta.value = (pre ? pre + String.fromCharCode(10) : '') + et + ': ';
      ta.focus();
      ta.setSelectionRange(ta.value.length, ta.value.length);
    });
    return modal;
  }
  return {
    open: function(btn){
      try {
        if(!ensure()) return;
        var img=btn.getAttribute('data-info-img'), name=btn.getAttribute('data-info-name'),
            tag=btn.getAttribute('data-info-tag'), desc=btn.getAttribute('data-info-desc');
        current = { img: img, name: name, tag: tag,
                    handle: btn.getAttribute('data-info-handle') };
        if(els.img){ els.img.src = img || ''; els.img.alt = name || ''; }
        if(els.name) els.name.textContent = name || '';
        if(els.tag){ els.tag.textContent = tag || ''; els.tag.hidden = !tag; }
        if(els.desc) els.desc.innerHTML = desc || '';
        if(els.brief){
          els.brief.value = '';
          var ph = btn.getAttribute('data-info-ph');
          els.brief.placeholder = ph || els.brief.getAttribute('data-ph-default') || '';
        }
        if(els.chipBox){
          var src = btn.getAttribute('data-info-chips') || '';
          els.chipBox.innerHTML = src.split('\u00b7').map(function(x){ return x.trim(); })
            .filter(Boolean).map(function(x){
              var e = x.replace(/[&<>"]/g, function(c){
                return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; });
              return '<button type="button" data-info-chip="' + e + '">' + e + '</button>';
            }).join('');
        }
        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.body.style.overflow = 'hidden';
        window.AMES_A11Y.trap(modal);
      } catch(e){}
    },
    addToQuote: function(){
      if(!ensure()) return;
      var Store = window.AMES && window.AMES.Store && window.AMES.Store.quote;
      if(!Store){ alert(window.AMES_T('quote_unavailable','Sistema preventivi non disponibile.')); return; }
      var uid = 'svc-' + Date.now() + '-' + Math.random().toString(36).slice(2,7);
      Store.add({
        id: (current && current.handle) || uid,
        variantId: uid,
        kind: 'servizio',
        title: current ? current.name : 'Servizio',
        url: window.location.pathname,
        image: current ? current.img : '',
        qty: 1,
        service: { brief: els.brief ? (els.brief.value || '').trim().slice(0, 900) : '',
                   page: document.title || '' }
      });
      this.close();
      window.location.href = ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'pages/preventivi';
    },
    close: function(){
      if(!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      window.AMES_A11Y.release();
    }
  };
})();

document.addEventListener('keydown', function(e){
  var m = document.querySelector('[data-info-modal]');
  if (e.key === 'Escape' && m && !m.hidden && window.AMES_INFO) window.AMES_INFO.close();
});

(function attachInfoListeners(){
  function attach(){
    document.querySelectorAll('[data-info-open]').forEach(function(btn){
      if (btn.__amesInfoBound) return; btn.__amesInfoBound = true;
      btn.addEventListener('click', function(e){ e.preventDefault(); window.AMES_INFO && window.AMES_INFO.open(btn); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();

/* ---- AMES_CMP: Modale di confronto prodotti con highlight migliore + reco ---- */
window.AMES_CMP = (function(){
  var modal=null, body=null, countEl=null, foot=null;

  function esc(s){ return window.AMES.esc(s); }
  function T(k, f){ return window.AMES_T(k, f); }
  /* Chiavi amministrative dei metafield: mai mostrarle nel confronto */
  var ADMIN_KEYS = ['data_provenance','typology_confidence','supplier','supplier_unique_key',
    'desc_source','desc_word_count','source_url','category_macro','breadcrumb',
    'n_variants_native','scheda_tecnica_pdf','short_description','last_sync_hash',
    'settore_root','specs_json','product_url_origine','web_sync_run'];
  /* Chiavi dove il badge "Migliore" non ha senso (codici, testo) */
  var NO_BEST = ['model_code','codice_articolo','ean','barcode','brand','typology',
    'typology_full','processes','certificazioni','tecnologia','modalita_lavoro','uso'];
  function flat(v){
    if(v && typeof v === 'object'){
      if('value' in v){ return [v.value, v.unit].filter(function(x){return x!=null&&x!=='';}).join(' '); }
      return Object.keys(v).map(function(k){ return flat(v[k]); }).join(', ');
    }
    var s = v==null?'':String(v);
    /* liste serializzate tipo "['EN60974-7']" → EN60974-7 */
    return s.replace(/^\[\s*'?/,'').replace(/'?\s*\]$/,'').replace(/'\s*,\s*'/g, ', ');
  }
  /* Unisce tutte le fonti di specifiche di un item, filtrando le chiavi admin:
     product_specs.specs_json (ricco) → product_specs.* → custom.specs (priorità) */
  function combineSpecs(it){
    var out = {};
    var meta = it.meta || {};
    var sj = meta.specs_json;
    if(sj && typeof sj === 'object'){
      Object.keys(sj).forEach(function(k){ out[k] = flat(sj[k]); });
    }
    Object.keys(meta).forEach(function(k){
      if(ADMIN_KEYS.indexOf(k) !== -1) return;
      if(!(k in out)) out[k] = meta[k];
    });
    var sp = it.specs || {};
    Object.keys(sp).forEach(function(k){ if(ADMIN_KEYS.indexOf(k) === -1) out[k] = sp[k]; });
    if(it.typology && !out.typology) out.typology = it.typology;
    if(it.brand && !out.brand) out.brand = it.brand;
    return out;
  }
  window.AMES_COMBINE_SPECS = combineSpecs;   /* riusato da pagina confronto e modal specifiche */
  window.AMES_FLAT_SPEC = flat;
  function num(v){
    if(v==null) return NaN;
    var s = String(v).replace(/[^\d,.\-]/g,'').replace(/\./g,'').replace(',','.');
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function ensure(){
    if(modal) return modal;
    modal = document.querySelector('[data-cmp-modal]');
    if(!modal) return null;
    body = modal.querySelector('[data-cmp-body]');
    countEl = modal.querySelector('[data-cmp-count]');
    foot = modal.querySelector('[data-cmp-foot]');
    return modal;
  }

  function bestIndexes(items, keys){
    /* per ogni key, ritorna indice del prodotto con valore numerico più alto */
    var map = {};
    keys.forEach(function(k){
      var nums = items.map(function(it){ return num((it.specs||{})[k]); });
      var hasNumeric = nums.some(function(n){ return !isNaN(n); });
      if(!hasNumeric){ map[k] = -1; return; }
      var maxIdx = 0, maxVal = -Infinity;
      nums.forEach(function(n,i){
        if(!isNaN(n) && n > maxVal){ maxVal = n; maxIdx = i; }
      });
      map[k] = maxIdx;
    });
    return map;
  }

  function recommendations(items){
    /* heuristic: aggrega specs + reco di ogni prodotto in suggerimenti */
    return items.map(function(it,i){
      var bestFor = [];
      var combined = it._combined || Object.assign({}, it.meta||{}, it.specs||{});
      Object.keys(combined).forEach(function(k){
        var v = num(combined[k]);
        if(!isNaN(v) && v > 0){
          if(/potenza|cv|kw|watt|w$|hp|kva/i.test(k)) bestFor.push('lavori che richiedono ' + k.toLowerCase());
          else if(/capacit|portat|volume|serbat/i.test(k)) bestFor.push('grandi volumi (' + k.toLowerCase() + ')');
          else if(/profond|altezz|lungh/i.test(k)) bestFor.push('lavori in ' + k.toLowerCase());
          else if(/pressione|bar/i.test(k)) bestFor.push('alte pressioni');
          else if(/giri|rpm|colpi|impatti/i.test(k)) bestFor.push('massima velocità di lavoro');
          else if(/peso|kg/i.test(k)) bestFor.push('movimentazione (peso ' + v + ')');
        }
      });
      if(it.typology) bestFor.unshift('uso tipico: ' + it.typology);
      return { item: it, idx: i, reco: it.reco || '', bestFor: bestFor };
    });
  }

  function render(){
    var items = (window.AMES && window.AMES.Store && window.AMES.Store.compare) ? window.AMES.Store.compare.all() : [];
    if(countEl) countEl.textContent = items.length === 1 ? T('cmp_count_one','1 prodotto a confronto')
      : items.length ? T('cmp_count_many','{n} prodotti a confronto').replace('{n}', items.length) : '';
    if(foot) foot.hidden = items.length === 0;

    if(!items.length){
      body.innerHTML = '<div class="ames-cmp-empty">'+
        '<svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h6l2 5-2 2a11 11 0 0 0 5 5l2-2 5 2v6a2 2 0 0 1-2 2A18 18 0 0 1 3 5a2 2 0 0 1 0-2z" opacity=".3"/><path d="M9 3v18M15 3v18"/></svg>'+
        '<h3>' + window.AMES_T('cmp_empty_title','Nessun prodotto da confrontare') + '</h3>'+
        '<p>' + window.AMES_T('cmp_empty_body','Aggiungi fino a 4 prodotti con il pulsante <strong>VS</strong> dalle collezioni o dalle pagine prodotto.') + '</p>'+
      '</div>';
      return;
    }

    /* Combina tutte le fonti specs (specs_json + product_specs.* + custom.specs), senza chiavi admin */
    items.forEach(function(it){
      it._combined = combineSpecs(it);
    });

    /* union dei chiavi su tutti gli item */
    var keys = [];
    items.forEach(function(it){ Object.keys(it._combined||{}).forEach(function(k){ if(keys.indexOf(k)===-1) keys.push(k); }); });

    /* helper per leggere il valore combinato */
    function getVal(it, k){ return (it._combined||{})[k]; }
    var best = (function(){
      var map = {};
      keys.forEach(function(k){
        /* Con un prodotto solo non c'e' nessuno da battere; e un codice
           (SKU, EAN, "Pgc 45B") non e' migliore perche' ha piu' cifre. */
        if(items.length < 2 || NO_BEST.indexOf(k) !== -1 || /(^|_)(sku|ean|gtin|barcode|cod|codice|code|pgc|id|mpn|art|articolo)(_|$)/i.test(k) || /^\d+$/.test(k)){ map[k] = -1; return; }
        /* Tabelle varianti dei fornitori: chiave = codice articolo, valore = EAN.
           Un EAN piu' alto non e' "migliore". */
        if(items.some(function(it){ return /^\s*\d{8,14}\s*$/.test(String(getVal(it,k)==null?'':getVal(it,k))); })){ map[k] = -1; return; }
        var nums = items.map(function(it){ return num(getVal(it,k)); });
        var hasNumeric = nums.some(function(n){ return !isNaN(n); });
        if(!hasNumeric){ map[k] = -1; return; }
        var maxIdx = 0, maxVal = -Infinity;
        nums.forEach(function(n,i){ if(!isNaN(n) && n > maxVal){ maxVal = n; maxIdx = i; } });
        /* C2 (20/10/2026): a pari valore non c'e' un migliore. Prima il badge
           andava al primo dei due ("18 ✓ Migliore" accanto a un altro 18). */
        var pari = nums.filter(function(n){ return !isNaN(n) && n === maxVal; }).length;
        map[k] = pari > 1 ? -1 : maxIdx;
      });
      return map;
    })();

    /* table */
    var html = '<div class="ames-cmp-scroll"><table class="ames-cmp-table">';
    html += '<thead><tr><th class="ames-cmp-rl"></th>';
    items.forEach(function(it,i){
      var key = it.variantId || it.id;
      html += '<th class="ames-cmp-col">'+
        '<div class="ames-cmp-media">'+(it.image?'<img src="'+esc(it.image)+'" alt="" loading="lazy" decoding="async" width="160" height="160">':'')+'</div>'+
        (it.brand?'<div class="ames-cmp-vendor">'+esc(it.brand)+'</div>':'')+
        '<a class="ames-cmp-name" href="'+esc(it.url)+'">'+esc(it.title)+'</a>'+
        '<button type="button" class="ames-cmp-rm" data-ames-remove="'+esc(key)+'" data-store="compare">'+esc(T('cmp_remove','Rimuovi'))+'</button>'+
      '</th>';
    });
    html += '</tr></thead><tbody>';

    if(!keys.length){
      html += '<tr><td class="ames-cmp-rl">' + window.AMES_T("specs_label","Specifiche") + '</td><td colspan="'+items.length+'" class="ames-cmp-empty-inline">' + window.AMES_T("specs_empty","Nessuna specifica disponibile per i prodotti selezionati.") + '</td></tr>';
    } else {
      /* etichetta umana dalla chiave metafield (snake_case → Title Case) */
      function label(k){
        /* solo la prima lettera maiuscola, come nella scheda ("Batterie in dotazione") */
        var s = String(k).replace(/[_-]/g,' ').replace(/\s+/g,' ').trim();
        /* P3: "Cap max foratura legno" e' l'abbreviazione del fornitore */
        s = s.replace(/^cap\.?\s+max\b/i, 'Capacità max');
        return s.charAt(0).toUpperCase() + s.slice(1);
      }
      keys.forEach(function(k){
        html += '<tr><td class="ames-cmp-rl">'+esc(label(k))+'</td>';
        items.forEach(function(it,i){
          var v = getVal(it,k);
          var has = v != null && v !== '';
          var isBest = best[k] === i;
          var cls = isBest ? ' is-best' : '';
          html += '<td class="ames-cmp-val'+cls+'">'+
            (has ? esc(flat(v)) : '<span class="ames-cmp-na">—</span>')+
            (isBest ? '<span class="ames-cmp-badge">✓ '+esc(T('cmp_best','Migliore'))+'</span>' : '')+
          '</td>';
        });
        html += '</tr>';
      });

      /* score row: solo se c'e' davvero qualcosa da confrontare */
      if(items.length > 1){
      var scores = items.map(function(){ return 0; });
      keys.forEach(function(k){ if(best[k] >= 0) scores[best[k]]++; });
      var topScore = Math.max.apply(null, scores);
      /* nessun dato numerico confrontabile: una riga "0/21 0/21" non dice niente */
      if(topScore > 0){
      html += '<tr class="ames-cmp-score"><td class="ames-cmp-rl"><strong>'+esc(T('cmp_score','Punteggio totale'))+'</strong></td>';
      items.forEach(function(it,i){
        var winner = scores[i] === topScore && topScore > 0;
        html += '<td class="ames-cmp-val'+(winner?' is-winner':'')+'">'+
          '<div class="ames-cmp-score-n">'+scores[i]+'<span class="ames-cmp-score-tot">/'+keys.length+'</span></div>'+
          (winner ? '<div class="ames-cmp-trophy">🏆 '+esc(T('cmp_top','Top scelta'))+'</div>' : '')+
        '</td>';
      });
      html += '</tr>';
      }
      }
    }
    html += '</tbody></table></div>';
    if(items.length === 1){
      html += '<p class="ames-cmp-need-more">'+esc(T('cmp_need_more','Aggiungi almeno un altro prodotto: con uno solo non c’è niente da confrontare.'))+'</p>';
    }

    /* recommendations */
    var recos = recommendations(items);
    html += '<div class="ames-cmp-recos">';
    html += '<h3 class="ames-cmp-recos-title">'+esc(T('cmp_reco_title','Consigli per i migliori utilizzi'))+'</h3>';
    /* "Ideale per" nasce da regole sulle parole italiane delle chiavi: fuori
       dall'italiano uscivano frasi italiane in mezzo alla pagina tradotta. */
    var itLang = /^it/i.test(document.documentElement.lang || 'it');
    html += '<div class="ames-cmp-recos-grid">';
    recos.forEach(function(r){
      html += '<div class="ames-cmp-reco">'+
        '<div class="ames-cmp-reco-head">'+
          (r.item.image?'<img src="'+esc(r.item.image)+'" alt="" loading="lazy" decoding="async" width="120" height="120">':'')+
          '<div><span class="ames-cmp-reco-vendor">'+esc(r.item.brand||'')+'</span>'+
          '<h4>'+esc(r.item.title)+'</h4></div>'+
        '</div>';
      if(r.reco){
        html += '<p class="ames-cmp-reco-text">'+esc(r.reco)+'</p>';
      }
      var ideale = itLang ? r.bestFor : [];
      if(ideale.length){
        html += '<p class="ames-cmp-reco-best"><strong>Ideale per:</strong> '+ideale.map(esc).join(' · ')+'</p>';
      }
      if(!r.reco && !ideale.length){
        html += '<p class="ames-cmp-reco-text ames-cmp-reco-empty">'+esc(T('cmp_reco_empty','Nessun consiglio specifico disponibile — apri la scheda prodotto per dettagli completi.'))+'</p>';
      }
      html += '<a class="ames-cmp-reco-link" href="'+esc(r.item.url)+'">'+esc(T('cmp_open_product','Apri scheda prodotto →'))+'</a>';
      html += '</div>';
    });
    html += '</div></div>';

    body.innerHTML = html;
  }

  return {
    open: function(e){
      if(e && e.preventDefault) e.preventDefault();
      if(!ensure()) return;
      render();
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      window.AMES_A11Y.trap(modal);
    },
    close: function(){
      if(!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden','');
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      window.AMES_A11Y.release();
    },
    refresh: function(){ if(modal && !modal.hidden) render(); }
  };
})();

/* re-render modal quando si rimuovono prodotti dallo store */
document.addEventListener('ames:store', function(){ window.AMES_CMP && window.AMES_CMP.refresh(); });
document.addEventListener('keydown', function(e){
  var m = document.querySelector('[data-cmp-modal]');
  if(e.key === 'Escape' && m && !m.hidden && window.AMES_CMP) window.AMES_CMP.close();
});

/* ---- AMES_QUOTE_M: Modale lista preventivi (anteprima rapida + qty + link a pagina) ---- */
window.AMES_QUOTE_M = (function(){
  var modal=null, body=null, countEl=null, foot=null;

  function esc(s){ return window.AMES.esc(s); }

  function ensure(){
    if(modal) return modal;
    modal = document.querySelector('[data-q-modal]');
    if(!modal) return null;
    body = modal.querySelector('[data-q-body]');
    countEl = modal.querySelector('[data-q-count]');
    foot = modal.querySelector('[data-q-foot]');
    return modal;
  }

  function render(){
    var Store = (window.AMES && window.AMES.Store && window.AMES.Store.quote);
    if(!Store || !body) return;
    var items = Store.all();
    var total = items.reduce(function(s,it){ return s + (it.qty||1); }, 0);
    if(countEl) countEl.textContent = items.length ? window.AMES_T('q_count','{n} voci · {q} pezzi').replace('{n}', items.length).replace('{q}', total) : '';
    if(foot) foot.hidden = items.length === 0;

    if(!items.length){
      body.innerHTML = '<div class="ames-q-empty">'+
        /* C4: la stessa icona (blocco appunti) del pulsante Preventivi, non una stella */
        '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="#i-quote"/></svg>'+
        '<h3>' + window.AMES_T('q_empty_title','Nessun prodotto nella lista preventivi') + '</h3>'+
        '<p>' + window.AMES_T("q_empty_body",'Aggiungi prodotti dalle pagine prodotto o dalle collezioni con il pulsante <strong>"Aggiungi ai preventivi"</strong>.') + '</p>'+
      '</div>';
      return;
    }

    body.innerHTML = items.map(function(it){
      var key = it.variantId || it.id;
      var isRental = it.kind === 'noleggio';
      var rentMeta = '';
      if(isRental && it.rental){
        var r = it.rental;
        var mode = r.deliveryMode === 'in_loco' ? window.AMES_T('delivery_onsite','Consegna in cantiere') : window.AMES_T('pickup','Ritiro in sede');
        rentMeta = '<div class="ames-q-row__meta"><strong>' + esc(window.AMES_T('rental','Noleggio')) + '</strong> · ' + (r.durationValue||1) + ' ' + esc(r.durationUnit||window.AMES_T('days','giorni')) + ' · ' + esc(mode) +
                   (r.deliveryMode === 'in_loco' && r.address ? ' · ' + esc(r.address) : '') + '</div>' +
                   (r.brief ? '<div class="ames-q-row__brief">' + esc(r.brief) + '</div>' : '');
      }
      return '<div class="ames-q-row'+(isRental?' is-rental':'')+'">'+
        '<div class="ames-q-row__media">'+(it.image?'<img src="'+esc(it.image)+'" alt="" loading="lazy" decoding="async" width="80" height="80">':'<span class="ames-q-row__ph"></span>')+'</div>'+
        '<div class="ames-q-row__info">'+
          (it.brand?'<div class="ames-q-row__vendor">'+esc(it.brand)+'</div>':'')+
          '<a class="ames-q-row__title" href="'+esc(it.url)+'">'+esc(it.title)+'</a>'+
          (it.variantTitle && it.variantTitle!=='Default Title' ? '<div class="ames-q-row__meta">'+esc(it.variantTitle)+'</div>' : '')+
          rentMeta+
        '</div>'+
        '<div class="ames-q-row__qty qty-stepper qty-stepper--quote">'+
          '<button type="button" data-q-down="'+esc(key)+'" aria-label="'+esc(window.AMES_T('qty_down','Diminuisci quantità'))+'">−</button>'+
          '<input type="text" inputmode="numeric" value="'+(it.qty||1)+'" data-q-input="'+esc(key)+'" aria-label="'+window.AMES_T("qty","Quantità")+'">'+
          '<button type="button" data-q-up="'+esc(key)+'" aria-label="'+esc(window.AMES_T('qty_up','Aumenta quantità'))+'">+</button>'+
        '</div>'+
        '<button type="button" class="ames-q-row__rm" data-ames-remove="'+esc(key)+'" aria-label="'+esc(window.AMES_T('cmp_remove','Rimuovi'))+': '+esc(it.title)+'">×</button>'+
      '</div>';
    }).join('');
  }

  /* delegated qty +/- inside modal */
  document.addEventListener('click', function(e){
    var up = e.target.closest('[data-q-up]'), dn = e.target.closest('[data-q-down]');
    if(!up && !dn) return;
    var Store = window.AMES && window.AMES.Store && window.AMES.Store.quote; if(!Store) return;
    var key = (up||dn).getAttribute('data-q-up') || (up||dn).getAttribute('data-q-down');
    var inp = document.querySelector('[data-q-input="'+CSS.escape(key)+'"]');
    var cur = inp ? (parseInt(inp.value,10)||1) : 1;
    Store.setQty(key, up ? cur+1 : cur-1);
  });
  document.addEventListener('change', function(e){
    var inp = e.target.closest('[data-q-input]'); if(!inp) return;
    var Store = window.AMES && window.AMES.Store && window.AMES.Store.quote; if(!Store) return;
    Store.setQty(inp.getAttribute('data-q-input'), parseInt(inp.value,10)||1);
  });

  return {
    open: function(e){
      if(e && e.preventDefault) e.preventDefault();
      if(!ensure()) return;
      render();
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      window.AMES_A11Y.trap(modal);
    },
    close: function(){
      if(!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden','');
      modal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      window.AMES_A11Y.release();
    },
    refresh: function(){ if(modal && !modal.hidden) render(); },
    clear: function(){
      var Store = window.AMES && window.AMES.Store && window.AMES.Store.quote; if(!Store) return;
      if(confirm(window.AMES_T('q_clear_confirm','Svuotare la lista preventivi?'))) Store.clear();
    }
  };
})();

document.addEventListener('ames:store', function(){ window.AMES_QUOTE_M && window.AMES_QUOTE_M.refresh(); });
document.addEventListener('keydown', function(e){
  var m = document.querySelector('[data-q-modal]');
  if(e.key === 'Escape' && m && !m.hidden && window.AMES_QUOTE_M) window.AMES_QUOTE_M.close();
});



/* ===== FIX 6 — Difesa immagini prodotto ==========================================
   Una PDP puo' mostrare come foto un file che E' la grafica "404 Not Found" del
   fornitore: risponde 200 (non e' un link rotto) ma e' il file sbagliato. Il tema
   non puo' saperlo da Liquid. Difesa lato client: mostra un PLACEHOLDER AMES neutro
   quando l'immagine e' rotta, vuota, o combacia con una firma nota (URL o dimensioni).
   La bonifica dei file veri resta lavoro di pipeline/admin: qui popolare
   window.AMES_IMG_BLOCKLIST (sottostringhe URL) e window.AMES_IMG_BADSIZES ("LxA"). */
(function(){
  var PH = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23F4F5F7'/%3E%3Cg fill='none' stroke='%23C3C8D0' stroke-width='8' stroke-linejoin='round' stroke-linecap='round'%3E%3Crect x='118' y='128' width='164' height='124' rx='12'/%3E%3Ccircle cx='163' cy='176' r='16'/%3E%3Cpath d='M140 240l44-44 34 30 30-24 40 38'/%3E%3C/g%3E%3Ctext x='200' y='302' text-anchor='middle' font-family='system-ui,sans-serif' font-size='21' fill='%239aa0a8'%3EImmagine non disponibile%3C/text%3E%3C/svg%3E";
  window.AMES_IMG_BLOCKLIST = window.AMES_IMG_BLOCKLIST || [];  // sottostringhe URL note-errore
  window.AMES_IMG_BADSIZES  = window.AMES_IMG_BADSIZES  || [];  // "larghezzaXaltezza" naturali note-errore
  function isBad(img){
    var src = img.currentSrc || img.src || "";
    if(!src || src === PH) return false;
    for(var i=0;i<window.AMES_IMG_BLOCKLIST.length;i++){ if(src.indexOf(window.AMES_IMG_BLOCKLIST[i])!==-1) return true; }
    if(img.complete && img.naturalWidth === 0) return true;              // immagine rotta
    if(img.naturalWidth){ var sig = img.naturalWidth+"x"+img.naturalHeight;
      if(window.AMES_IMG_BADSIZES.indexOf(sig)!==-1) return true; }      // firma dimensionale nota
    return false;
  }
  function fallback(img){ if(img.src!==PH){ img.src=PH; img.srcset=""; img.classList.add("ames-img-fallback"); } }

  /* Prima di sostituire una foto, chiederle conferma.
     `naturalWidth === 0` dopo un `load` riuscito sembra un'immagine rotta, ma
     non lo e' sempre: succede anche quando la pagina non e' visibile e `sizes`
     con `100vw` si risolve a zero, o quando il browser non ha ancora deciso
     quale candidata di `srcset` prendere. In quei casi la guardia buttava via
     una foto buona e ci metteva "Immagine non disponibile" — un danno
     irreversibile, perche' l'indirizzo originale viene perso.
     La conferma ricarica lo stesso indirizzo da solo, senza srcset: se anche
     cosi' non ha dimensioni, allora l'immagine e' rotta davvero. Costa niente,
     perche' il browser ce l'ha gia' in cache. */
  function confermaRotta(img, poi){
    var src = img.getAttribute("src") || "";
    if(!src || src.slice(0,5) === "data:") return poi(false);
    var sonda = new Image();
    sonda.onload  = function(){ poi(sonda.naturalWidth === 0); };
    sonda.onerror = function(){ poi(true); };
    sonda.src = src;
  }

  function guard(img){
    if(img.dataset.amesImgGuarded) return; img.dataset.amesImgGuarded="1";
    img.addEventListener("error", function(){ fallback(img); });
    function check(){
      if(!isBad(img)) return;
      /* Un indirizzo in lista nera o una firma dimensionale nota non hanno
         bisogno di conferma: li' si sa gia' che l'immagine e' sbagliata. */
      if(img.naturalWidth !== 0) return fallback(img);
      confermaRotta(img, function(rotta){ if(rotta) fallback(img); });
    }
    if(img.complete) check(); else img.addEventListener("load", check);
  }
  function scan(root){
    (root||document).querySelectorAll(".pcard__media img,.pdp__gallery img,.pdp__thumbs img,[data-product-img]").forEach(guard);
  }
  if(document.readyState !== "loading") scan();
  else document.addEventListener("DOMContentLoaded", function(){ scan(); });
  window.AMES_IMG_GUARD = { scan: scan, placeholder: PH };
})();
